import { i18n } from '@/i18n';
import { FormKitGlobalRule } from '@/types/interfaces/ValidationRule.interface';

/** Only for global use. @see https://formkit.com/essentials/validation#adding-a-rule-globally */
export const MoreThanFormKitRule: FormKitGlobalRule = {
  name: 'more_than',
  rule: (node, value: number): boolean => (node.value as unknown as number) > value,
  message: ({ name, args }) => i18n.global.t('validation.more', { name, value: args[0] }),
};
